import * as React from 'react'

import { usePageStatus } from 'modules/layout/components/ResponsivePage/FactorialOnePage/usePageStatus'
import Content from 'modules/shift_management/components/ShiftManagement/Content'
import Layout from 'modules/shift_management/components/ShiftManagement/Layout'
import useApplyFilters from 'modules/shift_management/hooks/useApplyFilters'
// TODO: This is a temporary import to make the app work. We should remove this and use GraphQL
import useFetchEmployees from 'modules/shift_management/hooks/useFetchEmployees'
import { useSchedule } from 'modules/shift_management/hooks/useSchedule'
import { useShiftsRows } from 'modules/shift_management/hooks/useShiftsRows'
import getStatusTagData from 'modules/shift_management/lib/getStatusTagData'

const MainPageOld = ({ children }: React.PropsWithChildren) => {
  useFetchEmployees()

  const [{ shiftsRows }] = useShiftsRows()
  const [{ conflictsCount, hasDrafts }] = useSchedule()
  const { filters } = useApplyFilters(shiftsRows)
  const { statusTag, statusVariant, statusLabel } = getStatusTagData({
    shiftsRows,
    conflictsCount,
    hasDrafts,
    filters,
  })
  const { setPageStatus } = usePageStatus()
  setPageStatus({ text: statusTag, variant: statusVariant, tooltip: statusLabel })

  return (
    <Layout>
      <Content />
      {children}
    </Layout>
  )
}

// I'm exporting this like this to make sure that we make the API of this
// component as explicit as possible and to try to enforce that the public
// interface it has is small.
export { MainPageOld }
